import(/* webpackMode: "eager" */ "/builds/crehana-team/frontend/crehana-frontend-apps/packages/compass.ui/dist/v2/index.js")